import { create } from 'zustand';

interface SettingsState {
  baseCurrency: string;
  setBaseCurrency: (currency: string) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  baseCurrency: 'CAD',
  setBaseCurrency: (currency) => set({ baseCurrency: currency }),
}));
